import { render, staticRenderFns } from "./DepartamentCells.vue?vue&type=template&id=6c6997f2&"
import script from "./DepartamentCells.vue?vue&type=script&lang=js&"
export * from "./DepartamentCells.vue?vue&type=script&lang=js&"
import style0 from "./DepartamentCells.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports